import { BellIcon, JustifyIcon, UserIcon } from 'assets'
import { useOutsideClick } from 'Hooks'
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { menuItems } from './menuItem'
import { DropDown } from 'components'
import { userType } from 'constant/const'
import { useDispatch, useSelector } from 'react-redux'
import { setSelectChannelId, setUserType } from 'store/action/settingsReducer'
import { logoutAction, onLogoutAction } from 'store/action/AuthRedux'
import { convertObjectToFormData } from 'utils/convertFormData'
import { createImageUrl } from 'utils/createImageUrl'
import axiosInstance from 'utils/axiosConfig'
import Swal from 'sweetalert2'
import {
   onResetVideoCount,
   setAllVideoDataAction,
   setPageNumberAction,
   toggleVideoList
} from 'store/action/videoReducer'

function TopBar(props) {
   const { isMini, onMobileMenu } = props
   const authData = useSelector((state) => state.user)
   const { userData } = authData
   const [channalOpen, setChannalOpen] = useState(false)
   const ref = useOutsideClick(() => setChannalOpen(false))
   const [activeItem, setActiveItem] = useState(null)
   const location = useLocation()
   const navigate = useNavigate()
   const settingData = useSelector((state) => state.settings)
   const { selectedUserTypes, selectedChannelID } = settingData
   const getParams = new URLSearchParams(location.search)
   const [filterSelected, setFilterSelected] = useState(
      getParams.get('userType') || selectedUserTypes || userType.OWNER
   )
   const dispatch = useDispatch()
   const [openProfileMenu, setOpenProfileMenu] = useState(false)

   const profileMenuRef = useOutsideClick(() => setOpenProfileMenu(false))
   const videoRedux = useSelector((state) => state.videoRedux)
   const { allVideoData } = videoRedux

   const onSelectedValue = (data) => {
      setFilterSelected(data)
      dispatch(setUserType(data))
      dispatch(setSelectChannelId(''))
      dispatch(onResetVideoCount())
      dispatch(setAllVideoDataAction([]))
      dispatch(setPageNumberAction(1))
      navigate(`/dashboard?userType=${data}`)
   }

   useEffect(() => {
      // Find the index of the current route in the menu items
      const index = menuItems.findIndex(
         (item) => item.path === `/${location.pathname.split('/')[1]}`
      )
      setActiveItem(index)
   }, [location.pathname])

   useEffect(() => {
      if (selectedUserTypes) {
         setFilterSelected(selectedUserTypes)
      }
      return () => {}
   }, [selectedUserTypes])

   // batch video message status call api every 20 sec.
   const fetchData = async () => {
      try {
         const response = await axiosInstance.get(
            `/yt/video_analysis_status?channel_id=${selectedChannelID}`
         )

         // ✅ Filter videos that are analyzed
         const successfulVideos =
            response.data?.data?.filter((video) => video.is_analyzed === true) || []
         if (successfulVideos.length > 0) {
            // ✅ Extract unique video names
            const uniqueVideoNames = [...new Set(successfulVideos.map((video) => video.title))]
            // ✅ Update allVideoData by matching video_id and merging data

            const updatedAllVideosList = allVideoData.map((video) => {
               const matched = successfulVideos.find((v) => v.video_id === video.video_id)
               console.log('matched', matched)
               return matched ? { ...video, ...matched } : video
            })

            // ✅ Dispatch updated data
            dispatch(setAllVideoDataAction(updatedAllVideosList))

            // ✅ Show SweetAlert
            Swal.fire({
               html: `
               <p>Your videos have been successfully analyzed.</p>
               <p><strong style="font-size: 15px;">Videos Analyzed (${
                  uniqueVideoNames.length
               }):</strong></p>
               <ul style="text-align: left; max-height: 200px; overflow-y: auto; padding-left: 1.2rem;">
                  ${uniqueVideoNames
                     .map(
                        (name, index) => `
                     <li style="font-size: 13px;">${index + 1}. ${name}</li>
                  `
                     )
                     .join('')}
               </ul>
            `,
               confirmButtonText: 'Okay',
               confirmButtonColor: '#286BFF',
               allowOutsideClick: false,
               theme: 'dark',
               customClass: {
                  popup: 'batch-alter-swal-popup',
                  actions: 'mt-1'
               }
            })

            // ✅ Toggle refresh state if needed
            // dispatch(toggleVideoList())
         } else {
            console.log('No analyzed videos found.')
            // Optional: Show a different alert or skip
         }
      } catch (error) {
         console.error('API error:', error)
      }
   }

   useEffect(() => {
      if (!selectedChannelID) return

      const interval = setInterval(() => {
         if (allVideoData && allVideoData.length > 0) {
            fetchData()
         } else {
            console.warn('allVideoData is not yet loaded.')
         }
      }, 20000)

      return () => clearInterval(interval)
   }, [selectedChannelID, allVideoData])

   return (
      <div className={`top-bar ${!isMini ? 'more-spach' : ''}`}>
         <div className="top-bar-section ">
            <div className="manu-list-section desktop-menu">
               {menuItems &&
                  menuItems.length > 0 &&
                  menuItems.map((item, i) => {
                     return (
                        <div
                           className={`manu-name-section ${activeItem === i ? 'active' : ''}`}
                           key={i}
                           onClick={() => {
                              navigate(`${item.path}${location?.search}`)
                           }}>
                           <Link to={`${item.path}${location?.search}`}>{item?.name}</Link>
                        </div>
                     )
                  })}
            </div>
            <div className="top-bar-box justify-icon " onClick={onMobileMenu}>
               <JustifyIcon />
            </div>
            <div className="d-flex gap-3 align-items-center ">
               <div className="manu-list-section border-0">
                  <DropDown
                     option={[
                        { label: userType.OWNER, value: userType.OWNER },
                        { label: 'EXTERNAL', value: userType.INFLUENCER }
                     ]}
                     value={filterSelected === userType.INFLUENCER ? 'EXTERNAL' : filterSelected}
                     onChangeOpt={onSelectedValue}
                  />
               </div>
               <div className="top-bar-box notification-icon">
                  <BellIcon />
               </div>
               <div
                  className="top-bar-box position-relative"
                  onClick={() => {
                     setOpenProfileMenu(!openProfileMenu)
                  }}
                  ref={profileMenuRef}>
                  {userData?.profile ? (
                     <img
                        src={createImageUrl(userData?.profile)}
                        style={{
                           width: '100%',
                           height: '100%',
                           borderRadius: '8px',
                           objectFit: 'contain',
                           maxWidth: '100%'
                        }}
                     />
                  ) : (
                     <UserIcon />
                  )}

                  {openProfileMenu && (
                     <div className="profile-wrap">
                        <ul>
                           <li
                              className="at-text-dark"
                              onClick={() => {
                                 navigate(`/profile${location?.search}`)
                              }}>
                              Profile
                           </li>
                           <li
                              className="at-text-dark"
                              onClick={() => {
                                 setOpenProfileMenu(false)
                                 let formData = convertObjectToFormData({
                                    refresh: userData?.refresh,
                                    access: userData?.access,
                                    user_history_id: userData?.user_history_id
                                 })
                                 dispatch(onLogoutAction(formData))
                              }}>
                              Log Out
                           </li>
                        </ul>
                     </div>
                  )}
               </div>
            </div>
         </div>
      </div>
   )
}

export default TopBar
